module.exports = __webpack_public_path__ + "img/purim-2016-thumbnail.d85c9f10.jpeg";